import type {IScrollItemOptions, IScrollOptions} from '@/components/parallax/types';
import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

// https://oxygen4fun.supadezign.com/tutorials/how-to-create-some-parallax-effects-with-gsap/
class ParallaxCircles {
    private wrapper: HTMLElement;

    /**
     * Элементы, которые двигаем
     * @type {HTMLElement[]}
     */
    private scrollItems: HTMLElement[];

    /**
     * Инициализация модуля
     * @param {IScrollOptions} options - параметры
     */
    public init(options: IScrollOptions): void {
        this.wrapper = options.wrapper;

        this._getElements();
        this._setAnimation();
    }

    /**
     * Получаем элементы со страницы
     * @private
     */
    private _getElements(): void {
        this.scrollItems = [...this.wrapper.querySelectorAll('.j-parallax-item')] as HTMLElement[];
    }

    private _setAnimation(): void {
        this.scrollItems.forEach((item: HTMLElement) => {
            const options: IScrollItemOptions = {
                multiplier: item.dataset['speed'] ? Number(item.dataset['speed']) : 1
            };

            if (options.multiplier) {
                const timeline = gsap.timeline({
                    scrollTrigger: {
                        trigger: item,
                        start  : 'top bottom',
                        end    : 'bottom top',
                        scrub  : 1
                        // для отладки анимаций
                        // markers: true
                    }
                });


                timeline.to(item, {
                    translateY: `${-1 * item.offsetHeight * options.multiplier}px`
                });
            }
        });
    }
}
export default ParallaxCircles;
